export interface UniqueKeyOptions {
    withoutDash: boolean;
}

export const uniqueKey = (options?: UniqueKeyOptions) => {
    const S4 = () => {
        return Math.floor(Math.random() * 0x10000 /* 65536 */).toString(16);
    };

    let result =
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4() +
        "-" +
        new Date().getTime() * 10000;

    if (options && options.withoutDash) {
        result = result.replace(/-/g, "");
    }

    return result;
};
